
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { vueCanvasPoster } from 'vue-canvas-poster';

import { Popup, Button } from 'vant';
Vue.use(Popup).use(Button);

@Component({
  components: {
    vueCanvasPoster,
  },
})
export default class Canvas extends Vue {
  @Prop() item!: any;
  showCanvas: boolean = false;

  src = '';
  painting = {};

  created() {
    setTimeout(() => {
      if (this.item.title) {
        this.painting = {
          width: '600px',
          height: '1000px',
          background: '#f4f5f7',
          views: [
            {
              type: 'text',
              text: `No.${this.item.PV}`,
              css: {
                top: '48px',
                left: '-16px',
                width: '600px',
                maxLines: 1,
                fontSize: '48px',
                fontWeight: 'bold',
                zIndex: '9',
                borderBottomStyle: 'solid',
                borderBottomWidth: '4px',
                textAlign: 'right',
              },
            },

            {
              type: 'image',
              // url: `${require('../assets/banner.png')}`,
              url: 'http://img5.imgtn.bdimg.com/it/u=2654012588,2977869697&fm=11&gp=0.jpg',
              css: {
                top: '150px',
                left: '25px',
                width: '550px',
                height: '332px',
              },
            },

            {
              type: 'text',
              text: `作品名称：${this.item.title}`,
              css: {
                top: '510px',
                left: '25px',
                color: '#4F4E4E',
                fontSize: '26px',
                fontWeight: 'bold',
                width: '550px',
                lineHeight: '33px',
                maxLines: 1,
              },
            },
            {
              type: 'text',
              text: `作者： ${this.item.name}`,
              css: {
                top: '550px',
                left: '25px',
                color: '#4F4E4E',
                fontSize: '26px',
                fontWeight: 'bold',
                width: '550px',
                lineHeight: '33px',
                maxLines: 1,
              },
            },
            {
              type: 'text',
              text: `${this.item.college}-${this.item.major}`,
              css: {
                top: '590px',
                left: '25px',
                color: '#4F4E4E',
                fontSize: '26px',
                fontWeight: 'bold',
                width: '545px',
                lineHeight: '33px',
                maxLines: 1,
              },
            },
            {
              type: 'text',
              text: `指导老师：${this.item.tearcher}`,
              css: {
                top: '630px',
                left: '25px',
                color: '#4F4E4E',
                fontSize: '26px',
                fontWeight: 'bold',
                width: '545px',
                lineHeight: '33px',
                maxLines: 1,
              },
            },
            {
              type: 'text',
              text: `点赞量：${this.item.votes}`,
              css: {
                top: '670px',
                left: '25px',
                color: '#4F4E4E',
                fontSize: '26px',
                fontWeight: 'bold',
                width: '545px',
                lineHeight: '33px',
                maxLines: 1,
              },
            },
            {
              type: 'text',
              text: `作品材料：${this.item.material}`,
              css: {
                top: '710px',
                left: '25px',
                color: '#4F4E4E',
                fontSize: '26px',
                fontWeight: 'bold',
                width: '545px',
                lineHeight: '33px',
                maxLines: 1,
              },
            },

            {
              type: 'text',
              text: `我是第${this.item.PV}位`,
              css: {
                top: '850px',
                left: '25px',
                color: '#4F4E4E',
                fontSize: '26px',
                fontWeight: 'bold',
                width: '545px',
                lineHeight: '33px',
                maxLines: 1,
              },
            },
            {
              type: 'text',
              text: '川美-开放的六月展览参观者',
              css: {
                top: '890px',
                left: '25px',
                color: '#4F4E4E',
                fontSize: '26px',
                fontWeight: 'bold',
                width: '545px',
                lineHeight: '33px',
                maxLines: 1,
              },
            },
            {
              type: 'text',
              text: '邀请您来跟我一起鉴赏',
              css: {
                top: '930px',
                left: '25px',
                color: '#4F4E4E',
                fontSize: '26px',
                fontWeight: 'bold',
                width: '545px',
                lineHeight: '33px',
                maxLines: 1,
              },
            },

            {
              type: 'qrcode',
              content: 'https://github.com/sunniejs/vue_canvas_poster',
              css: {
                bottom: '20px',
                right: '26px',
                color: '#000',
                width: '130px',
                height: '130px',
              },
            },
          ],
        };
      }
    }, 1000);
  }
  success(src: any) {
    // 设置img的src
    this.src = src;
  }
  fail(err: any) {
    console.log('fail', err);
  }
}
